import BaseStore from '@store/table'
import Api from '@api/shou_xie/setMeal'

class Store extends BaseStore {
  $listApi = Api.listApi

  $getParams = () => {
    return {
      commodity_type: 1,
      rating: 1
    }
  }
}
export default new Store()
